'use client';

import { useMemo } from 'react';
import { TypeIcon } from 'src/components';
import { StrategyNewOpportunityBadge } from '../Strategy/shared';
interface ProviderNameCellProps {
  row: any;
}

const ProviderNameCell: React.FC<ProviderNameCellProps> = ({ row }) => {
  const provider = useMemo(() => {
    return row.provider ? row.provider : row;
  }, [row]);

  const type =
    provider?.soc_type ||
    provider?.object_type?.toLowerCase() ||
    provider?.content_type ||
    provider?.type;
  const date_added = row?.added_at;
  const last_refreshed = row?.last_refreshed;

  return (
    <div className="flex flex-col justify-center w-full h-full gap-2 cursor-pointer">
      <div
        id={`provider-name-cell-${provider.provider_id}`}
        className="flex items-center w-full gap-2"
      >
        <div className="flex items-center gap-2 w-full overflow-hidden">
          <div className="flex items-center w-[1.1rem] h-full shrink-0">
            <TypeIcon type={type} className="text-link" />
          </div>
          <div className="text-sm font-semibold truncate min-w-0">
            <div
              role="button"
              tabIndex={0}
              aria-label={`View provider ${provider.name || 'details'}`}
              className="text-link hover:text-sky-600 transition-colors cursor-pointer truncate"
              data-testid={`strategy-center-provider-${provider.provider_id}`}
            >
              <span>{provider.name || 'n/a'}</span>
            </div>
          </div>
          <StrategyNewOpportunityBadge
            dateAdded={date_added}
            lastRefreshed={last_refreshed}
          />
        </div>
      </div>
    </div>
  );
};

export default ProviderNameCell;
